import React, { MouseEventHandler } from 'react'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import type { ButtonOwnProps } from '@mui/material/Button'

function CustomButton({
    text,
    onClick,
    disabled,
    type,
    color = 'primary',
    variant = 'contained',
    endIcon,
    loading,
}: {
    text: string,
    onClick?: MouseEventHandler,
    disabled?: boolean,
    type?: 'submit',
    color?: ButtonOwnProps["color"],
    variant?: ButtonOwnProps["variant"],
    endIcon?: React.ReactNode,
    loading?: boolean,
}) {

    return (
        <Button
            sx={{
                paddingX: 4,
                paddingY: 1.5,
                borderRadius: 5,
                fontSize: '1rem',
                position: 'relative',
            }}
            color={color}
            variant={variant}
            onClick={onClick ? onClick : () => {}}
            disabled={disabled || loading}
            type={type}
            endIcon={endIcon}
        >
                {loading &&
                    <CircularProgress size={28} sx={{
                        position: 'absolute',
                        top: 'calc(50% - 14px)',
                        left: 'calc(50% - 14px)',
                    }}/>
                }
                {text}
        </Button>
    )
}

export default CustomButton
